module.exports = __webpack_public_path__ + "img/trx.a30f2a55.svg";